/**
 * Created by alvinoktavianus on 5/24/17.
 */

import React from 'react';
import _ from 'lodash';

class DropdownSelect extends React.Component {
  static renderSubscriptionPlansOption(options) {
    return _.map(options, (rules, key) => {
      return (
        <option key={key} value={rules.name}>
          {rules.name}
        </option>
      );
    });
  }

  render() {
    const { input, options, id, dir } = this.props;
    return (
      <label className="mk-select-label">
        <select {...input} className={`mk-select`} id={id} dir={dir}>
          {DropdownSelect.renderSubscriptionPlansOption(options)}
        </select>
      </label>
    );
  }
}

DropdownSelect.propTypes = {};

export default DropdownSelect;
